const isNull = (value) => value === null;
export default isNull;
